<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="sheetModal"
      :title="modalTitle"
      centered
      hide-footer
      scrollable
      :size="size"
      content-class="shadow"
      :no-close-on-backdrop="restrictiveClose"
      :no-close-on-esc="restrictiveClose"
      header-bg-variant="3v3"
      header-text-variant="light"
      @hide="guardClose"
      @hidden="modalHidden"
    >
      <component
        v-if="modalContentComponent"
        :is="modalContentComponent"
        ref="content"
        :item-selected="item"
      />
    </b-modal>

    <b-modal
      ref="closeConfirm"
      title="Alterações não salvas"
      centered
      @hidden="runCloseAction"
    >
      {{ closeQuestionText }}
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="chooseCloseAction(null)">
          Continuar editando
        </b-button>
        <b-button size="sm" variant="danger" @click="chooseCloseAction('discard')">
          Fechar e descartar
        </b-button>
        <b-button v-if="showSaveOption" size="sm" variant="success" @click="chooseCloseAction('save')">
          Salvar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FarmDAPTable from "@/pages/registerPages/Management/components/FarmDAPTable.vue";
import ManualStation from "@/pages/registerPages/Management/ManualStation.vue";
import SectorEquipmentsTable from "@/pages/registerPages/Sectors/components/SectorEquipmentsTable.vue";
import GroupEquipamentsTable from "@/pages/registerPages/Users/components/GroupEquipamentsTable.vue";

export default {
  components: {
    FarmDAPTable,
    ManualStation,
    SectorEquipmentsTable,
    GroupEquipamentsTable,
  },
  props: {
    modalPrefix: {
      type: String,
      default: "",
    },
    modalSize: {
      type: String,
      default: "",
    },
    modalContentComponent: {
      type: String,
      default: "",
    },
    value: {
      required: true,
      type: Boolean,
    },
    restrictiveClose: {
      default: false,
      type: Boolean,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      forceClose: false,
      closeQuestionText: "",
      closeAction: null,
      showSaveOption: false,
    };
  },
  computed: {
    size() {
      return this.modalSize;
    },
    modalTitle() {
      const itemName = this.item && this.item.NAME;

      return [this.modalPrefix, itemName].filter((val) => val).join(" ");
    },
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // Contrato opcional do conteúdo: `closeQuestion()` devolve a pergunta antes de fechar (ou nada, se
    // pode fechar), e `requestSave()` abre o fluxo de salvamento dele.
    guardClose(bvEvent) {
      const content = this.$refs.content;
      if (this.forceClose || !content || typeof content.closeQuestion !== "function") return;
      const question = content.closeQuestion();
      if (!question) return;

      // A confirmação é assíncrona e o `hide` só aceita veto síncrono: barra sempre e refaz na resposta.
      bvEvent.preventDefault();
      this.closeQuestionText = question;
      this.showSaveOption = typeof content.requestSave === "function";
      this.$refs.closeConfirm.show();
    },
    chooseCloseAction(action) {
      this.closeAction = action;
      this.$refs.closeConfirm.hide();
    },
    // Agir só depois que o diálogo saiu evita dois modais em transição ao mesmo tempo.
    runCloseAction() {
      const action = this.closeAction;
      this.closeAction = null;
      if (action === "discard") {
        this.forceClose = true;
        this.$refs.sheetModal.hide();
      } else if (action === "save") {
        this.$refs.content.requestSave();
      }
    },
    modalHidden() {
      this.forceClose = false;
      // Emitir um evento para o componente pai
      this.$emit("close-action-modal");
    },
  },
};
</script>
